<div
  [class]="'card' + class"
  [ngStyle]="{
    background: 'var(--app-' + background + '-color)',
    color: 'var(--app-' + textColor + '-color)',
    cursor: cursor,
    padding: padding,
    'border-radius': borderRadius,
    'border-style': borderStyle,
    'border-width': borderWidth,
    'border-color': 'var(--app-' + borderColor + '-color)'
  }">
  <ng-content></ng-content>
</div>
